"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidatorPipeline = exports.NO_OP_VALIDATOR = exports.Validator = exports.BaseValidator = exports.ValidationError = void 0;
var ValidationError;
(function (ValidationError) {
    class MissingDefinition extends Error {
    }
    ValidationError.MissingDefinition = MissingDefinition;
})(ValidationError || (exports.ValidationError = ValidationError = {}));
class BaseValidator {
    name;
    constructor(name) {
        this.name = name;
    }
}
exports.BaseValidator = BaseValidator;
class Validator extends BaseValidator {
    validationFn;
    constructor(name, validationFn) {
        super(name);
        this.validationFn = validationFn;
    }
    validate(value, context) {
        return this.validationFn(value, context);
    }
    toString() {
        return `Validator(${this.name})`;
    }
}
exports.Validator = Validator;
exports.NO_OP_VALIDATOR = new Validator("NoOp", () => []);
class ValidatorPipeline extends BaseValidator {
    validators;
    constructor(name, validators) {
        super(name);
        this.validators = validators;
    }
    async validate(value, context) {
        const validatorResults = await Promise.all(this.validators.map((validator) => validator.validate(value, context)));
        return validatorResults.flat();
    }
    toString() {
        const tab = "    ";
        const prefixAndSuffix = this.validators.length > 0 ? "\n" : "";
        const childValidatorList = (prefixAndSuffix +
            this.validators.map((validator) => validator.toString()).join("\n")).replaceAll("\n", `\n${tab}`);
        return `Pipeline(${this.name}, length=${this.validators.length}) [${childValidatorList}${prefixAndSuffix}]`;
    }
}
exports.ValidatorPipeline = ValidatorPipeline;
//# sourceMappingURL=BaseValidators.js.map